import React,{Component,Fragment} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {listClinicData,getTestFile,Updateclinicentry,getFileFromServer,listSupportingDocuments} from '../actions';
import Wrappercontainer from "../components/Wrappercontainer";
import {Alert, AlertTitle} from "@material-ui/lab";
import { DataGrid } from '@material-ui/data-grid';
import CloseIcon from '@material-ui/icons/Close';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import Viewer, { Worker } from "@phuocng/react-pdf-viewer";
import Labelcontrol from "../components/Labelcontrol";
import {FileCopy} from '@material-ui/icons';
import utils from '../utils';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Backdrop,
  CircularProgress,
  Slide,
  Dialog,
  AppBar, Typography, Grid, Button, Snackbar, Paper, ButtonGroup, List, ListItem, ListItemIcon, ListItemText
} from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import renderIf from "render-if";
import {CANARY_YELLOW, PURPLE_COLOR} from "../constants";
import AppBarTop from "../components/AppBarTop";
let flag = true;
var loadedData = [];
let invoiceItem = {};
const darnecolumns = [
  { field: 'Reviewstatus', headerName: 'Status',width:125,
    renderCell: (params) => (
      <div style={{width:'100%',height:'100%'}}>
        {renderIf(params.value == 'PENDING')(
          <div style={{width: '100%', height: '100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
          <Typography style={{
               textAlign:'center',
               fontWeight:'600',
             color:'black'
            }}>PENDING</Typography>
        </div>)}

        {renderIf(params.value == 'VERIFY')(
          <div style={{width: '100%', height: '100%',backgroundColor:CANARY_YELLOW,display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography style={{
              textAlign:'center',
              fontWeight:'600',
              color:'white'
            }}>VERIFY</Typography>
          </div>)}

        {renderIf(params.value == 'DONE')(
          <div style={{width: '100%', height: '100%',backgroundColor:'green',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography style={{
              textAlign:'center',
              fontWeight:'600',
              color:'white'
            }}>DONE</Typography>
          </div>)}
      </div>
    )
  },
  { field: 'filename', headerName: 'File',width:85,
    renderCell: (params) => (
      <div style={{width:'100%',height:'100%'}}>
        {renderIf(params.value.toString().length>2)(<FileCopy style={{color:PURPLE_COLOR,height:32,width:32,marginLeft:5,marginTop:5}}/>)}
      </div>
    )
  },
  { field: 'UHID', headerName: 'UHID',width:125},
  { field: 'PatientName', headerName: 'Patient Name',width:500  },
  { field: 'TYPE', headerName: 'TYPE',width:100   },
  { field: 'IPNo', headerName: 'IP No',width:150   },
  { field: 'BillDate', headerName: 'Bill Date' ,width:150  },
  { field: 'TotalOutstanding', headerName: 'Total Outstanding' ,width:200  },
  { field: 'OutstandingDoctorAllocation', headerName: 'Outstanding Doctor Allocation' ,width:250  },
  { field: 'OutstandingHospital', headerName: 'Outstanding Hospital' ,width:200  },
  { field: 'DoctorRange', headerName: 'DR Range' ,width:125  },
  { field: 'DarneRemarksFeb2021', headerName: 'Darne Remarks FEB 2021' ,width:500  },
  { field: 'SWANRemarksFeb2021', headerName: 'SWAN Remarks FEB 2021' ,width:500  }

];
const wellkincolumns = [
  { field: 'Reviewstatus', headerName: 'Status',width:125,
    renderCell: (params) => (
      <div style={{width:'100%',height:'100%'}}>
        {renderIf(params.value == 'PENDING')(
          <div style={{width: '100%', height: '100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography style={{
              textAlign:'center',
              fontWeight:'600',
              color:'black'
            }}>PENDING</Typography>
          </div>)}

        {renderIf(params.value == 'VERIFY')(
          <div style={{width: '100%', height: '100%',backgroundColor:CANARY_YELLOW,display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography style={{
              textAlign:'center',
              fontWeight:'600',
              color:'white'
            }}>VERIFY</Typography>
          </div>)}

        {renderIf(params.value == 'DONE')(
          <div style={{width: '100%', height: '100%',backgroundColor:'green',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography style={{
              textAlign:'center',
              fontWeight:'600',
              color:'white'
            }}>DONE</Typography>
          </div>)}
      </div>
    )
  },
  { field: 'filename', headerName: 'File',width:85,
    renderCell: (params) => (
      <div style={{width:'100%',height:'100%'}}>
        {renderIf(params.value.toString().length>2)(<FileCopy style={{color:PURPLE_COLOR,height:32,width:32,marginLeft:5,marginTop:5}}/>)}
      </div>
    )
  },
  { field: 'UHID', headerName: 'UHID',width:125  },
  { field: 'PatientName', headerName: 'Patient Name',width:500  },
  { field: 'TYPE', headerName: 'TYPE',width:100   },
  { field: 'IPNo', headerName: 'IP No',width:150   },
  { field: 'BillDate', headerName: 'Bill Date' ,width:150  },
  { field: 'TotalOutstanding', headerName: 'Total Outstanding' ,width:200  },
  { field: 'OutstandingDoctorAllocation', headerName: 'Outstanding Doctor Allocation' ,width:250  },
  { field: 'OutstandingHospital', headerName: 'Outstanding Hospital' ,width:200  },
  { field: 'DoctorRange', headerName: 'DR Range' ,width:125  },
  { field: 'WHREMARKS311020', headerName: 'Wellkin Remarks 31.10.21' ,width:500  },
  { field: 'SWANRECON260220', headerName: 'SWAN Remarks FEB 2021' ,width:500  }

];
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const base64toBlob = (data ) => {
  // Cut the prefix `data:application/pdf;base64` from the raw base 64
  const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

  const bytes = atob(base64WithoutPrefix);
  let length = bytes.length;
  let out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: 'application/pdf' });
};

class SwanView extends Component{
constructor(props) {
  super(props);
  this.state = {
    width: 0, height: 0,processedValues:[], clinicselection:'',loading:false,showModal:false,link:'',
    totaloutstanding:'',doctoroutstanding:'',hospitaloutstanding:'',drrange:'',comments:'',patientname:"",IPNo:"",BillNo:'',
    showSnackbar:false,snackbarMessage:'',pdfExists:false,BillDate:"",UHID:"",DoctorDisallowedAmount:'',
    disallowedhelpertext:'',disallowederror:false,
    commentshelpertext:'',commentserror:false,
    newAllowedRaw:"",newAllowed:"",icdcode:"",scaleofcost:"",supportingdocuments:[],vettingselection:''
  };

}

componentDidMount() {
  window.scrollTo(0, 0);
}

  handleClinicSelector(e){
  let clinic = e.target.value;
  this.setState({clinicselection:clinic})
    if(clinic!==""){
      this.props.listClinicData(clinic);
      this.props.listSupportingDocuments(clinic);
      this.setState({loading:true});
    }
  }

  handleVettingStatusChange(e){
  let vetting = e.target.value;
  if(vetting!==""){
    var filteredData = loadedData.filter(function (e) {
      return e.Reviewstatus == vetting;
    });
    if(vetting == 'ALL'){
      filteredData = loadedData
    }
    this.setState({vettingselection:vetting,processedValues:filteredData});
  }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.clinicdata){
      if(nextProps.clinicdata.clinicdata){
        loadedData = nextProps.clinicdata.clinicdata;
        this.setState({processedValues:nextProps.clinicdata.clinicdata,
          supportingdocuments:nextProps.clinicdata.supportingfiles,loading:false,showSnackbar:false});
      }
    }

    if(nextProps.fileserver && nextProps.fileserver.base64){
      const blob = base64toBlob(nextProps.fileserver.base64);
      const url = URL.createObjectURL(blob);
      this.setState({link:url});
    }

    if(nextProps.files.data){
      this.setState({link:nextProps.files.data.link});
    }

    if(nextProps.rowreducer && nextProps.rowreducer.success && flag){
      this.setState({showSnackbar:true,snackbarMessage:"Reloading data..."});
      this.props.listClinicData(this.state.clinicselection);
      flag = false;
    }
    //
    // if(nextProps.supportingdocuments){
    //   this.setState({supportingdocuments:nextProps.supportingdocuments});
    // }
  }

  /**
   * Handles Row Click
   */
  handleRowClick(e){
  flag = true;
  let {OutstandingDoctorAllocation,OutstandingHospital,PatientName,TotalOutstanding,DoctorRange,IPNo,BillNo,Comments,filename,filepath,
    BillDate,UHID} = e;
    invoiceItem = e;
  let pdfExists = false;
  if(filename.toString().length > 0 && filepath.toString().length > 0){
    this.props.getFileFromServer(
      filename,
      filepath
    );
    pdfExists = true;
  }
  let icdcode= '';
  let scaleofcost = '';
  if(e.icdcode){icdcode = e.icdcode;}
  if(e.scaleofcost){scaleofcost = e.scaleofcost;}

  this.setState({showModal:true,totaloutstanding:TotalOutstanding,doctoroutstanding:OutstandingDoctorAllocation,comments:Comments,
    hospitaloutstanding:OutstandingHospital,drrange:DoctorRange,patientname:PatientName,IPNo:IPNo,BillNo:BillNo,link:'',pdfExists:pdfExists,BillDate:BillDate,UHID:UHID,
    icdcode:icdcode,scaleofcost:scaleofcost});
  }

  //UPDATE TRIGGER FROM ROW HANDLER -- DONE/VERIFY
  updateRow(status){
    var _login,_agency,_company = "";
    if(this.props.auth.data){
      const {login,agency,company} = this.props.auth.data;
      _login = login ;
      _agency = agency;
      _company = company;
    }
    let { clinicselection,totaloutstanding,doctoroutstanding,hospitaloutstanding,comments,BillNo,DoctorDisallowedAmount} = this.state;
    let faultState = false;
    if(status=='VERIFY'){
      //No Validation
    }
    var newState = {};
    if(status == 'DONE'){
      if(DoctorDisallowedAmount.toString().length>1 && comments.toString().length==0){
        faultState=true;
        newState.commentshelpertext = 'Please enter reason(s) for disallowing';
        newState.commentserror = true;
      }
      console.log(newState)
      if(faultState){this.setState(newState);}
    }

    if(!faultState){
      this.setState({loading:true,showModal:false});
      this.props.Updateclinicentry(clinicselection,BillNo,totaloutstanding,doctoroutstanding,hospitaloutstanding,comments,true,status,new Date().toLocaleString(),DoctorDisallowedAmount,this.state.icdcode,this.state.scaleofcost,_login);
    }
  }

  handleDisallow(e){
    let doctoroutstanding = parseFloat(this.state.doctoroutstanding.toString().replace(",",""));
    this.setState({disallowedhelpertext:'',disallowederror:false,DoctorDisallowedAmount:e.target.value,
      newAllowedRaw:doctoroutstanding-parseFloat(e.target.value),
      newAllowed:'Rs '+ utils.numberWithCommas(doctoroutstanding-parseFloat(e.target.value))})
  }

  handleLoadSupportingDocument(fileitem){
    this.setState({link:''});
    this.props.getFileFromServer(
      fileitem.filename,
      fileitem.filepath
    );
  }

  render() {
  //Default state
  let columns = darnecolumns;
  if(this.state.clinicselection=='wellkin'){columns = wellkincolumns;}
  if(this.state.clinicselection=='darne'){columns = darnecolumns;}
    return(
      <Fragment>
        <AppBarTop handleLogout={()=>this.props.history.push("/")}/>
        <Wrappercontainer large>
          <div style={{marginTop:50}}/>
          <FormControl style={{margin:15,width:'30%'}}>
            <InputLabel id="demo-simple-select-helper-label">Clinic Name</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={this.state.clinicselection}
              onChange={(e)=>this.handleClinicSelector(e)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={'darne'}>Clinique Darne</MenuItem>
              <MenuItem value={'wellkin'}>Wellkin</MenuItem>
            </Select>
            <FormHelperText>Choose a clinic from this dropdown.</FormHelperText>
          </FormControl>

          {
            renderIf(loadedData.length > 0)(
              <FormControl style={{margin:15,width:'30%'}}>
                <InputLabel id="demo-simple-select-helper-label">Vetting Status</InputLabel>
                <Select
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  value={this.state.vettingselection}
                  onChange={(e)=>this.handleVettingStatusChange(e)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={'ALL'}>ALL</MenuItem>
                  <MenuItem value={'PENDING'}>PENDING</MenuItem>
                  <MenuItem value={'VERIFY'}>VERIFY</MenuItem>
                  <MenuItem value={'DONE'}>DONE</MenuItem>
                </Select>
                <FormHelperText>Choose a Clinic first then apply this filter.</FormHelperText>
              </FormControl>
            )
          }

          <div style={{ height: 500, width: '100%' }}>
            <DataGrid onRowClick={(e)=>this.handleRowClick(e.row)} rows={this.state.processedValues} columns={columns}   />
          </div>

          <Backdrop style={{color:'#fff',zIndex:10000}} open={this.state.loading}>
            <Alert  severity={'info'}>
              <div style={{display:'flex',flexDirection:'row'}}>
                <AlertTitle>Please wait ...</AlertTitle>
                <CircularProgress style={{marginLeft:75}} size={20} color={'black'}/>
              </div>
              <strong>Data are being determined</strong>
            </Alert>
          </Backdrop>

          {/*VIEW PDF AREA*/}
          <Dialog fullScreen open={this.state.showModal} onClose={()=>this.setState({showModal:false})} TransitionComponent={Transition}>
            <AppBar className={{position: 'relative'}}>
              <Toolbar>
                <IconButton edge="start" color="inherit" onClick={()=>this.setState({showModal:false})} aria-label="close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" onClick={()=>this.setState({showModal:false})} >
                  {this.state.patientname}
                </Typography>
              </Toolbar>
            </AppBar>
            <Grid container spacing={3} style={{marginTop:55}}>
              <Grid item xs={8} >
                {renderIf(this.state.link.length>0)(<Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.js">
                  <div style={{height: "750px"}}>
                    <Viewer fileUrl={this.state.link}/>
                  </div>
                </Worker>)}

                {this.state.pdfExists &&
                  <div style={{height: "750px",width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                    {renderIf(this.state.link.toString().length==0)(
                      <CircularProgress size={40} color={PURPLE_COLOR}/>
                    )}
                  </div>}

                {!this.state.pdfExists &&
                  <div style={{height: "750px"}}>
                    <Typography style={{marginTop:200,textAlign:'center'}}>No PDF Available</Typography>
                  </div> }
              </Grid>
              <Grid item xs={4} >
                <div style={{width:'85%'}}>
                  <div style={{height:5}}/>
                  <Grid container spacing={3}>
                  <Grid item xs>
                  <Labelcontrol
                    title="IP No : "
                    content={this.state.IPNo}
                  />
                  </Grid>
                  <Grid item xs>
                  <Labelcontrol
                    title="Bill Date: "
                    content={this.state.BillDate}
                  />
                  </Grid>
                  </Grid>

                  <Labelcontrol
                    title="Patient No (UHID) : "
                    content={this.state.UHID}
                  />
                  <div style={{height:5}}/>
                  <Paper elevation={12} style={{padding:5}}>
                    <Labelcontrol
                      title="Total Outstanding : "
                      content={this.state.totaloutstanding}
                    />
                    {/*<TextField value={this.state.doctoroutstanding} onChange={e=>this.setState({doctoroutstanding:e.target.value})} fullWidth label={'Outstanding Doctor Allocation'} variant="outlined" />*/}
                    <Labelcontrol
                      title="Outstanding Doctor Allocation : "
                      content={this.state.doctoroutstanding}
                    />
                    <Labelcontrol
                      title="Outstanding Hospital : "
                      content={this.state.hospitaloutstanding}
                    />
                  </Paper>

                  <div style={{height:20}}/>

                  <TextField helperText={this.state.disallowedhelpertext} error={this.state.disallowederror}
                    fullWidth value={this.state.DoctorDisallowedAmount} onChange={e=>this.handleDisallow(e)}
                    label={'Doctor Amount Disallowed'} type="number" variant="outlined" onKeyDown={ utils.formatInput }/>

                  <div style={{height:20}}/>
                  <TextField helperText={this.state.commentshelpertext} error={this.state.commentserror}
                    fullWidth value={this.state.comments} onChange={e=>this.setState({commentshelpertext:'',commentserror:false,comments:e.target.value})}
                    rowsMax={10} multiline label={'Remarks'} variant="outlined" />

                  <div style={{height:20}}/>

                  <Grid container={3} style={{width:'100%'}}>
                    <Grid item xs style={{marginRight:5}}>
                      <TextField fullWidth value={this.state.icdcode} onChange={e=>this.setState({icdcode:e.target.value})}
                                 rowsMax={10} multiline label={'ICD 10 Code'} variant="outlined" />
                    </Grid>
                    <Grid item xs style={{marginLeft:5}}>
                      <TextField fullWidth value={this.state.scaleofcost} onChange={e=>this.setState({scaleofcost:e.target.value})}
                                 rowsMax={10} multiline label={'Scale Of Cost'} variant="outlined" /></Grid>
                  </Grid>

                  <div style={{height:35}}/>


                  <ButtonGroup fullWidth disableElevation variant="contained" color="primary">
                  <Button fullWidth variant="contained" style={{backgroundColor:CANARY_YELLOW,color:'white'}} color="primary" onClick={()=>this.updateRow('VERIFY')}>
                    verify
                  </Button>

                  <Button fullWidth variant="contained" color="primary" onClick={()=>this.updateRow('DONE')}>
                    Confirm
                  </Button>
                  </ButtonGroup>

                  <div style={{height:25}}/>
                  {
                    renderIf(this.state.newAllowedRaw.toString().length>0)(
                      <Alert severity="info">Doctor Amount Allowed: {this.state.newAllowed}</Alert>
                    )
                  }


                  {/*SUPPORTING DOCUMENTS LISTVIEW*/}

                  <Grid container={3} style={{width:'100%'}}>
                    <Grid item xs> <Typography style={{marginTop:5}}>List of Document(s)</Typography> </Grid>
                    <Grid item xs> <Button onClick={()=>this.handleLoadSupportingDocument(invoiceItem)} variant={'outlined'}>Reload Invoice</Button> </Grid>
                  </Grid>


                  <List dense={true}>
                    {
                      this.state.supportingdocuments.map(item=>{

                        if(item.filename.split("-")[0]==this.state.IPNo){
                        return(
                          <div>
                            <ListItem style={{cursor:'pointer'}} onClick={()=>this.handleLoadSupportingDocument(item)}>
                              <ListItemIcon>
                                <FileCopy />
                              </ListItemIcon>
                              <ListItemText
                                primary={item.filename}
                              />
                            </ListItem>
                            <div style={{height:0.5,width:'100%',backgroundColor:'gray',marginTop:2,marginBottom:2}}/>
                          </div>

                        )}
                      })}
                  </List>



                </div>
               </Grid>
            </Grid>
          </Dialog>
          {/*VIEW PDF AREA*/}

          <Snackbar anchorOrigin={{vertical: 'bottom',horizontal: 'right'}}
                    open={this.state.showSnackbar} autoHideDuration={2000}
                    onClose={()=>this.setState({showSnackbar:false})}>
            <Alert onClose={()=>this.setState({showSnackbar:false})} severity={'success'}>
              <AlertTitle>{this.state.snackbarMessage}</AlertTitle>
            </Alert>
          </Snackbar>
        </Wrappercontainer>
        {/*<CsvDownload data={this.state.processedValues} />*/}
      </Fragment>
    )
  }
}

const mapStateToProps = (data) => {
  return data;
}

export default connect(mapStateToProps,{listClinicData,getTestFile,Updateclinicentry,getFileFromServer,listSupportingDocuments})(withRouter(SwanView));
